import {
    FormErrors,
    FormValidation,
    validateEmailAddress,
    validateForm,
} from '../../../../entities/@forms/FormValidation/FormValidationService';
import { RequestResetPasswordFormData } from '../../../../entities/@forms/RequestResetPasswordForm/RequestResetPasswordForm';

export type RequestResetPasswordFormErrors = FormErrors<RequestResetPasswordFormData>;

export const validateRequestResetPasswordFormData = (formData: RequestResetPasswordFormData): FormValidation<RequestResetPasswordFormErrors> => {
    const errors: RequestResetPasswordFormErrors = {
        username: validateEmailAddress(formData.username),
    };

    return validateForm<RequestResetPasswordFormErrors>(errors);
};
